import { render, staticRenderFns } from "./SubmitIssuePullout.vue?vue&type=template&id=0dec5c64&scoped=true&"
import script from "./SubmitIssuePullout.vue?vue&type=script&lang=js&"
export * from "./SubmitIssuePullout.vue?vue&type=script&lang=js&"
import style0 from "./SubmitIssuePullout.vue?vue&type=style&index=0&id=0dec5c64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dec5c64",
  null
  
)

export default component.exports